import { Icon } from '@theneatcompany/nui'

export default Icon
